import { useEffect, useState } from 'react'
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { LinkIcon, PlusIcon, QuestionMarkCircleIcon, CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { Label, Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { useSelector, useDispatch } from 'react-redux'
import { format } from 'date-fns';
import { v4 as uuidv4 } from 'uuid';

export default function ViewRequestsDialog(props) {

  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const [open, setOpen] = useState(props.showViewRequestDialog)
  const user = useSelector((state) => state.auth.user);
  const selectedRequest = props.selectedRequest;
  const selectedUser = props.selectedUser;
  const [buttonsVisible, setButtonsVisible] = useState(selectedRequest.status === 'pending' ? true : false);
  const [status, setStatus] = useState(selectedRequest.status);
  let data = props.data;

  const handleClose = () => {
    setOpen(false);
    props.setShowViewRequestDialog(false);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const action = e.nativeEvent.submitter.value;
    let status = 'pending';
    if (action === 'accept') {
      status = 'accepted';
      setStatus(status);
    } else if (action === 'decline') {
      // Handle decline logic
      status = 'declined';
      setStatus(status);
    }
    
    const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/notification/requests/${selectedRequest.id}?viewed=true&status=${status}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : '',
        'Api-Name': 'user-api',
      },
    });
    const response_json = await response.json();
    console.log(response_json);
    if (response_json.status === 'success') {
      if (selectedRequest.isCustomerRequest && status === 'accepted') {
        const provider_update_response = await fetch(`${process.env.REACT_APP_SERVICE_API_URL}/service/providers`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'Api-Name': 'service-api',
          },
          body: JSON.stringify({            
            providerId: selectedRequest.requesterId,
            customer: {
              id: user.id,
              name: user.name,
            }
          })
        });
        const response_json = await provider_update_response.json();

        const customer_update_response = await fetch(`${process.env.REACT_APP_SERVICE_API_URL}/service/customers`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'Api-Name': 'service-api',
          },
          body: JSON.stringify({            
            customerId: user.id,
            provider: {
              id: selectedUser.id,
              name: selectedUser.name,
            }
          })
        });
        const cust_response_json = await customer_update_response.json();
        if (response_json.status === 'success' && cust_response_json.status === 'success') {
          return setButtonsVisible(false);
        }
      }
      const updatedData = data.requests.map(req => {
        if (req.id === selectedRequest.id) {
          req.status = status;
          req.viewed = true;
        }
        return req;
      }
      );
      props.setData({ ...data, requests: updatedData });      
      setButtonsVisible(false);
    }
  }

  const handleDelete = async () => {
    const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/notification/requests/${selectedRequest.id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : '',
        'Api-Name': 'user-api',
      },
    });
    const response_json = await response.json();

    if (response_json.status === 'success') {
      const updatedData = data.requests.filter(req => req.id !== selectedRequest.id);
      props.setData({ ...data, requests: updatedData });
      handleClose();
    }
  }

  return (
    <Dialog className="relative z-10" open={open} onClose={handleClose}>
      <div className="fixed inset-0" />
      <div className="fixed inset-0 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
            <DialogPanel
              transition
              className="pointer-events-auto w-screen max-w-md transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
            >
              <form className="flex h-full flex-col divide-y divide-gray-200 bg-sec-dark shadow-xl" onSubmit={handleSubmit}>
                <div className="h-0 flex-1 overflow-y-auto border-l-2 border-pri-green border-b-0 shadow-2xl shadow-pri-green">
                  <div className="bg-pri-dark px-4 py-6 sm:px-6">
                    <div className="flex items-center justify-between">
                      <DialogTitle className="text-base font-semibold leading-6 text-pri-white">View Connect Request</DialogTitle>
                      <div className="ml-3 flex h-7 items-center">
                        <button
                          type="button"
                          className="relative rounded-full bg-pri-yellow text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                          onClick={() => handleClose()}
                        >
                          <span className="absolute -inset-2.5" />
                          <span className="sr-only">Close panel</span>
                          <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                        </button>
                      </div>
                    </div>
                    {/* <div className="mt-1">
                      <p className="text-sm text-pri-white">
                        Search for a user to add as a customer.
                      </p>
                    </div> */}
                  </div>
                  <div className="flex flex-1 flex-col justify-between">
                    <div className="divide-y divide-gray-200 px-4 sm:px-6">
                      <div className="space-y-6 pb-5 pt-6">
                        <div className="flex items-center justify-between gap-3">
                        <img alt="" src={ selectedUser?.imageUrl} className="h-12 w-12 flex-none rounded-full bg-gray-50" />
                          <div className="min-w-0 flex-auto">
                            <p className="text-sm font-semibold leading-6 text-pri-white">
                              <span className="" />
                              {selectedUser?.name} 
                              <span className="text-pri-gray"> ({selectedUser?.username}) </span>
                            </p>
                            <p className="mt-1 text-xs leading-5 text-pri-gray">
                              <time dateTime={selectedRequest.date}>{selectedRequest.date}</time>
                            </p>
                          </div>
                        </div>                        
                        <div>
                          <label htmlFor="message" className="block text-sm font-medium leading-6 text-pri-white">
                            Message
                          </label>
                          <div className="mt-2">
                            <textarea
                              id="message"
                              name="message"
                              rows={4}
                              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                              defaultValue={selectedRequest.message}
                              readOnly
                            />
                          </div>
                        </div>   
                        {status && (
                          <div className="mt-4 text-sm font-medium leading-6 text-pri-white">
                            Status: {status.toUpperCase()}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-shrink-0 justify-end px-4 py-4 border-l-2 border-pri-green">
                <button
                  type="button"
                  className="rounded-md bg-pri-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-pri-dark hover:bg-gray-50"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                {buttonsVisible ? (
                  <>
                    <button
                      type="submit"
                      name="action"
                      value="accept"
                      className="ml-4 inline-flex justify-center rounded-md bg-pri-green px-3 py-2 text-sm font-semibold text-pri-dark shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Accept
                    </button>
                    <button
                      type="submit"
                      name="action"
                      value="decline"
                      className="ml-4 inline-flex justify-center rounded-md bg-pri-green px-3 py-2 text-sm font-semibold text-pri-dark shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Decline
                    </button>
                  </>
                ) : (
                  <button
                    type="button"
                    className="ml-4 inline-flex justify-center rounded-md bg-pri-green px-3 py-2 text-sm font-semibold text-pri-dark shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    onClick={handleDelete}
                  >
                    Delete
                  </button>
                )}
              </div>
              </form>
            </DialogPanel>
          </div>
        </div>
      </div>
    </Dialog>
  )
}
